import { Divider, Stack, Typography } from '@mui/material';
import { CaseStudyContentDto } from 'tdc-web-backend/case-studies-content/schemas';
import { useTranslation } from 'react-i18next';
import { formatDateFns } from '../../../../../../../utils/helpers';
import ControlledTextInput from '../../../../../../../components/custom-inputs/ControlledTextInput';
import PitchFeedbackInput from '../../../../../TimedProjects/TimedProjectsDetails/components/PitchFeedbackInput';

const ScoreInputs = ({ data }: { data: CaseStudyContentDto }) => {
  const { t, i18n } = useTranslation();
  const feedbackFields = [
    {
      title: t('caseStudies.feedback.quality.title'),
      description: t('caseStudies.feedback.quality.description'),
      ratingInputName: 'score.qualityScore',
      textInputName: 'score.qualityText',
    },
    {
      title: t('caseStudies.feedback.budget.title'),
      description: t('caseStudies.feedback.budget.description'),
      ratingInputName: 'score.budgetScore',
      textInputName: 'score.budgetText',
    },
    {
      title: t('caseStudies.feedback.schedule.title'),
      description: t('caseStudies.feedback.schedule.description'),
      ratingInputName: 'score.scheduleScore',
      textInputName: 'score.scheduleText',
    },
    {
      title: t('caseStudies.feedback.willingnessToRefer.title'),
      description: t('caseStudies.feedback.willingnessToRefer.description'),
      ratingInputName: 'score.recommendationScore',
      textInputName: 'score.recommendationText',
    },
  ];

  return (
    <Stack
      spacing={1}
      // width={'60%'}
      sx={{ width: { xs: '100%', md: '60%' }, border: '1px solid', borderColor: 'primaryDark.200' }}
    >
      <Stack p={4}>
        <Typography variant="heading1" p={1} color="primaryDark.600">
          {data?.title}
        </Typography>
        <Typography variant="body3" p={1} py={3} color="primaryDark.500">
          {formatDateFns(data?.published, i18n.language).toUpperCase()}
        </Typography>
      </Stack>
      <Divider />
      <Stack p={4}>
        <ControlledTextInput
          required
          multiline
          minRows={5}
          name="summarization"
          placeholder={t('common.type')}
          label={t('caseStudies.feedback.quote')}
          showErrorAlways
        />

        {feedbackFields.map((item) => (
          <Stack py={2} key={item.title}>
            <PitchFeedbackInput
              key={item.title}
              description={item.description}
              title={item.title}
              ratingInputName={item.ratingInputName}
              textInputName={item.textInputName}
              showEditor
            />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default ScoreInputs;
